import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { ReferralsTerm } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class ReferralsTermsCollectionHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadTerms(): Observable<ReferralsTerm[]> {
    return this.httpApi.get(`/referral/terms`).pipe(map(data => data.terms));
  }

  public updateTerms(terms: ReferralsTerm[]): Observable<ReferralsTerm[]> {
    return this.httpApi
      .patch('/referral/terms', null, {
        terms,
      })
      .pipe(map(data => data.terms));
  }
}
